import { Pipe, PipeTransform } from '@angular/core'
import { CurrencyConfigService } from '../../service/currency-config.service'

@Pipe({
  name: 'currencyLocale',
  pure: true,
  standalone: true,
})
export class CurrencyLocalePipe implements PipeTransform {
  private cache = new Map<string, string>()

  constructor(private currencyConfigService: CurrencyConfigService) {}

  transform(value: number, locale?: string, currency?: string): string {
    if (isNaN(value) || value === null) return ''

    const finalLocale = locale || this.currencyConfigService.getLocale()
    const finalCurrency = currency || this.currencyConfigService.getCurrency()

    const cacheKey = `${value}-${finalLocale}-${finalCurrency}`

    if (this.cache.has(cacheKey)) {
      const value = this.cache.get(cacheKey)
      if (value !== undefined) {
        return value
      }
    }

    const formattedValue = new Intl.NumberFormat(finalLocale, {
      style: 'currency',
      currency: finalCurrency,
      maximumFractionDigits: 0,
    }).format(value)

    this.cache.set(cacheKey, formattedValue)
    return formattedValue
  }
}
